import axios from "axios";
import { toast } from "./swal";

const api = axios.create({
  baseURL: process.env.VUE_APP_API_HOST + "/api/v1",
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

// Add a response interceptor
api.interceptors.response.use(
  function(response) {
    console.log(`%c API RESPONSE ${response.config.url} - ${response.config.method}`, "background: #7DCEE7; color: #111", response);
    return response;
  },
  function(error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error

    console.error(`API ERROR RESPONSE ${error.config.url}`, error.response || error);

    if (error.response) {
      let err = error.response;

      if (err.status === 401) {
        // toast.fire(err.data.message, "", "warning");
        // window.localStorage.clear();
        // window.location.reload();
      } else if (err.status === 403) {
        // toast.fire(err.data?.message || "No tiene los permisos suficientes para realizar esta acción.", "", "warning");
      } else if (err.status === 404) {
        toast.fire({ title: "Página o Recurso no encontrado o no disponible", icon: "warning" });
      } else if (err.status === 422) {
        err.errorsForHumans = errorsForHumans(err);
        if (err.data.message && !err.errorsForHumans) {
          toast.fire({
            title: err.data.message,
            icon: "error",
          });
        }
      } else if (err.status === 500) {
        toast.fire({
          title: err.data?.message || "Error desconocido por favor inténtelo de nuevo más tarde o contacte con el administrador",
          icon: "error",
        });
      }
    }

    return Promise.reject(error);
  }
);

const errorsForHumans = (err) => {
  let errors = err.data?.errors || {};
  let errorsForHumans = null;

  if (Object.keys(errors).length) {
    errorsForHumans = ["<strong>Por favor revisa los siguientes datos:</strong>"];

    Object.keys(errors).forEach((errorKey) => {
      errorsForHumans.push(errors[errorKey][0]);
    });

    errorsForHumans = errorsForHumans.join("<br/>");
  }

  return errorsForHumans;
};

export default api;
